
import { Component, Vue, Watch } from "vue-property-decorator";
import { searchCustomer } from "@/api/customer";
import Pagination from "@/components/Pagination/index.vue";
import {
  uploadDataConnection,
  getDataConnectionList,
  downloadUnMatchedFile,
  generateDocuments,
} from "@/api/invoice";
import { getReportOssUrl } from "@/api/report";
import { deepClone } from "@/utils/deepClone";
import { getYesCopy, postYesCopy } from "@/api/order-library";

@Component({
  name: "dataConnection",
  components: {
    Pagination,
  },
})
export default class extends Vue {
  public table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any,
  };
  private searchForm = [
    {
      label: "请选择客人",
      prop: "customerId",
      key: "customerId",
      type: "select",
      value: "",
      options: [],
      placeholder: "请选择客人",
      remote: true,
      remote_method: this.getCustomer,
      clearable: true,
      resetKey: { label: "abbreviation", value: "id" },
    },
  ];
  public copyForm = [
    {
      label: "客人1",
      prop: "customerId",
      key: "customerId",
      type: "select",
      value: "",
      options: [],
      placeholder: "请选择客人1",
      remote: true,
      remote_method: this.getCustomer,
      clearable: true,
      resetKey: { label: "abbreviation", value: "id" },
    },
    {
      label: "客人2",
      prop: "copiedCustomerId",
      key: "copiedCustomerId",
      type: "select",
      value: "",
      options: [],
      placeholder: "请选择客人2",
      remote: true,
      remote_method: this.getCustomer,
      clearable: true,
      resetKey: { label: "abbreviation", value: "id" },
    },
    {
      label: "类型",
      prop: "type",
      key: "type",
      type: "select",
      value: "",
      options: [
        {
          label: "下单库",
          value: "ORDER",
        },
        {
          label: "报价库",
          value: "QUOTE",
        },
      ],
      placeholder: "请选择类型",
      clearable: true,
      resetKey: { label: "label", value: "value" },
    },
    {
      label: "任务类型",
      prop: "taskId",
      key: "taskId",
      type: "select_dis",
      value: "",
      options: [],
      placeholder: "请选择任务类型",
      clearable: true,
      resetKey: { label: "fileName", value: "taskId", disabled: "canCopy" },
    },
  ];
  public tableCol = [
    {
      label: "客人编号",
      prop: "customerCode",
      key: "customerCode",
      show: true,
      disabled: false,
    },
    {
      label: "客人简称",
      prop: "customerAbb",
      key: "customerAbb",
      show: true,
      disabled: false,
    },
    {
      label: "处理阶段",
      prop: "state",
      key: "state",
      show: true,
      disabled: false,
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "下载校验结果",
          code: "",
          click: "handleDownloadJYJG",
        },
        {
          name: "下载在库产品未匹配列表",
          code: "",
          click: "handleDownloadList",
        },
        {
          name: "生成单据",
          code: "",
          click: "handleCreateDJ",
          value: "待生成单据",
          key: "state",
        },
      ],
      show: true,
      disabled: false,
      width: 300,
    },
  ];
  private showFileList = false;
  private files: File[] = [];
  private customerId: any = "";
  private listLoading = true;

  private customerId1 = "";
  private copiedCustomerId = "";
  private type = "";

  created() {
    this.init();
  }
  activated() {
    this.init();
  }
  private init() {
    this.getCustomer();
    this.getList();
  }
  private async getCustomer(name = "") {
    const res: any = await searchCustomer({ keyword: name });
    this.searchForm[0].options = res;
    this.copyForm[0].options = res;
    this.copyForm[1].options = res;
  }
  private addFile(file: File) {
    this.files.push(file);
  }
  public loading: Boolean = false;
  private async getList() {
    this.loading = true;
    let params = {
      pageNumber: this.table.pageNumber,
      pageSize: this.table.pageSize,
    };
    let { total, content }: any = await getDataConnectionList(params);
    this.table.total = +total;
    console.log("content", content);
    this.table.list = content;
    this.table.list.map((item) => {
      item.state = item.status.desc;
    });
    this.table.list = deepClone(this.table.list);
    this.loading = false;
    setTimeout(() => {
      this.listLoading = false;
    }, 0.3 * 1000);
  }

  private querySearch(data) {
    if (data.customerId === "") {
      this.$notify({
        title: "提示",
        message: "请先选择客人",
        type: "error",
      });
    } else {
      this.customerId = data.customerId;
      this.$refs["upload"]["$refs"]["upload-inner"].handleClick();
    }
  }
  private changeValueCopy(e) {
    console.log("选择返回的e", e);
    if (e.key === "type") {
      this.type = e.value;
    }
    if (e.key === "copiedCustomerId") {
      this.copiedCustomerId = e.value;
    }
    if (e.key === "customerId") {
      this.customerId1 = e.value;
    }
    if (
      e.key === "type" ||
      e.key === "copiedCustomerId" ||
      e.key === "customerId"
    ) {
      this.getTaskList();
    }
  }
  private async getTaskList() {
    if (!this.type || !this.copiedCustomerId || !this.customerId1) {
      return;
    }
    this.copyForm[3].value = "";
    let params = {
      customerId: this.customerId1,
      copiedCustomerId: this.copiedCustomerId,
      type: this.type,
    };
    const res: any = await getYesCopy(params);
    this.copyForm[3].options = res;
  }
  private async queryCopy(e) {
    if (!e.customerId) {
      this.$notify({
        title: "提示",
        message: "请选择客人1",
        type: "error",
      });
      return;
    }
    if (!e.copiedCustomerId) {
      this.$notify({
        title: "提示",
        message: "请选择客人2",
        type: "error",
      });
      return;
    }
    if (!e.taskId) {
      this.$notify({
        title: "提示",
        message: "请选择任务类型",
        type: "error",
      });
      return;
    }
    let data = {
      customerId: e.customerId,
      needCopyCustomerId: e.copiedCustomerId,
      taskId: e.taskId,
    };
    await postYesCopy(data);
    this.copyForm[3].value = "";
    this.getTaskList();
    this.$notify({
      title: "提示",
      message: "复制成功",
      type: "success",
    });
  }
  private async handleUpload() {
    let formData = new window.FormData();
    formData.append("file", this.files.pop());
    let params = {
      customerId: this.customerId,
    };
    await uploadDataConnection(params, formData);
    this.$notify({
      title: "提示",
      message: "上传成功",
      type: "success",
    });
    this.getList();
  }
  private async handleCreateDJ(row) {
    let params = {
      customerId: row.row.customerId,
    };
    this.table.list[
      this.table.list.findIndex((e) => e.customerId === row.row.customerId)
    ].state = "生成中";
    this.table.list = deepClone(this.table.list);
    console.log("this.table.list", this.table.list);
    await generateDocuments(params);
    this.$notify({
      title: "提示",
      message: "生成单据完成",
      type: "success",
    });
    this.getList();
  }
  private async handleDownloadList(row) {
    let params = {
      customerId: row.row.customerId,
    };
    await downloadUnMatchedFile(params);
  }
  private async handleDownloadJYJG(row) {
    const res: any = await getReportOssUrl(row.row.matchFileOssUrl);
    window.open(res);
  }
}
